export default __webpack_public_path__ + "static/media/35.3218887a.jpg";